module.exports = __webpack_public_path__ + "img/矩形 2626.57d1da26.png";